import React from "react";

export default function SkillItem({ icon, name }) {
  return (
    <li>
      <img src={icon} alt={name} loading="lazy"/>
      <span>{name}</span>
    </li>
  );
}
